import { useState, useRef } from "react";
import Config from "../../Config";

import { PieChart, Pie, Cell, BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer, } from 'recharts';
import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";

function ReviewYear(props)
{


    const [refreshView, setRefreshView] = useState(props.userData.refreshView);




    const getDateYmd = () => {
        const dateObj = new Date();
        const month   = dateObj.getUTCMonth() + 1; // months from 1-12
        const day     = dateObj.getUTCDate();
        const year    = dateObj.getUTCFullYear();

       // const newDate = year + "/" + month + "/" + day;

        // Using template literals:
       // const newDate = `${year}/${month}/${day}`;

        // Using padded values, so that 2023/1/7 becomes 2023/01/07
        const pMonth        = month.toString().padStart(2,"0");
        const pDay          = day.toString().padStart(2,"0");
        const newPaddedDate = `${year}-${pMonth}-${pDay}`;

        return newPaddedDate;
}

    const [filterParam, setFilterParam] = useState({ 
        rok: (new Date()).getFullYear() ,
             
    });


    const [tab, setTab] = useState(null);



    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_rap,static_y', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }




    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
 
         setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
         
         var modX = val.length % 3;
         if(  val.length == 0 || modX == 0 || msg =='combo')
        setTab(null);  
 
         props.mainView.writeFilter(filedName, val);
     }



    if(refreshView != props.userData.refreshView)
    {
        setRefreshView(props.userData.refreshView);
        setTab(null);
    }


    if(tab == null)
    {
        setTab([]);
        getTab();
    }




    const colors = ['#6aa44b', '#f25c37' ];
    const colors2 = ['#69b6bd', '#5482ac' ];

   
    var fData = new Array();
    var pData = new Array();

    if(tab != null)
    {
        fData = [
            {  nazwa: "Rozliczone",  wartosc: tab.f_zaplacone },
            {  nazwa: "Nierozliczone", wartosc: tab.f_niezaplacone },
        ];

        pData = [
            {  nazwa: "Rozliczone",  wartosc: tab.p_zaplacone },
            {  nazwa: "Nierozliczone", wartosc: tab.p_niezaplacone },
        ];
    }

  
    

    //  var barData = [
     //   { id: 1, name: "styczeń" ,"zapłacone": 120, "niezapłacone": 34  },
      //  { id: 1, name: " luty"  , "zapłacone": 80, "niezapłacone": 222 },
      //];

      var barData  = [];
      var barData2  = [];

      if(tab != null)
      {
            barData = tab.w_ilosci;
            barData2 = tab.w_kwoty;
      }


    return <div className="raports">
          
          <div className="rap_filter_right">

                <div className="filter_controll">   
                        <label>Rok: </label>                             
                        <InputComboRok   userData={props.userData}  mainView={props.mainView}  value={filterParam.rok}   valChange={valChangeListener} goNext={null} name="rok" placeholder={": "}  noempty="1"   />
                </div> 
             

          </div>

          <div className="rap_inline rap_half">

                 <div className="rap_title">Wystawione faktury, {filterParam.rok}</div>   
                <ResponsiveContainer width="100%" height={300}>
                        <PieChart width={200} height={300}>
                                    <Pie
                                    data={fData}
                                    dataKey="wartosc"
                                    nameKey="nazwa"
                                    cx="50%"
                                    cy="50%"
                                    label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                                    labelLine={false}
                                    >
                                    {
                                        fData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                                        ))
                                    }
                                    </Pie>
                        </PieChart>
                    </ResponsiveContainer>
          </div>


          <div className="rap_inline rap_half">

            <div className="rap_title">Przelewy i zwroty, {filterParam.rok}</div>   
            <ResponsiveContainer width="100%" height={300}>
                <PieChart width={200} height={300}>
                            <Pie
                            data={pData}
                            dataKey="wartosc"
                            nameKey="nazwa"
                            cx="50%"
                            cy="50%"
                            label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                            labelLine={false}
                            >
                            {
                                pData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={colors2[index % colors2.length]} />
                                ))
                            }
                            </Pie>
                </PieChart>
            </ResponsiveContainer>
            </div>
                    

            <div className="rap_inline">
                <div className="rap_title">Ilość wplata wg. miesięcy, {filterParam.rok} </div>   
                <ResponsiveContainer width="100%" height={400}>
                                <BarChart
                                    data={barData}
                                    margin={{
                                    top: 5,
                                    right: 30,
                                    left: 20,
                                    bottom: 5,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="Miesiąc" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="Przelew tradycyjny" fill="#5482ac" />
                                    <Bar dataKey="Przelew online" fill="#c67912" />
                                </BarChart>
                </ResponsiveContainer>
            </div>

            <div className="rap_inline">
                <div className="rap_title">Suma wpłat wg. miesięcy, {filterParam.rok} </div>   
                <ResponsiveContainer width="100%" height={400}>
                                <BarChart
                                    data={barData2}
                                    margin={{
                                    top: 5,
                                    right: 30,
                                    left: 20,
                                    bottom: 5,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="Miesiąc" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="Przelew tradycyjny" fill="#5482ac" />
                                    <Bar dataKey="Przelew online" fill="#c67912" />
                                </BarChart>
                </ResponsiveContainer>
            </div>

    </div>
}


export default ReviewYear;